import './downloadRequestToast.css';
import {forwardRef} from "react";

const DownloadRequestToast = forwardRef((props, ref) => {

    let {status, message, jobID, style, ...rest} = props;

    let content = null;

    if (status === 'success') {
        content = (<>
            {message}
            {jobID}
            </>)
    }

    if (status === 'fail') {
        content = (<>
            Failed
            </>)
    }

    return (<div style={style} ref={ref} {...rest}>
        {content}
        asdfads
    </div>)
});

export default DownloadRequestToast;
